import React, { Component } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import styled from "styled-components";
import CreatePageModal from "@alboom/custom-page-settings/CreatePageModal";

import { addPage } from "store/actions/headerActions";
import Dropdown from "shared/components/Dropdown";
import PageSelectList from "editor/components/PageSelectList";

const Wrapper = styled.div`
  &:hover {
    background-color: rgb(243, 243, 243);
  }

  > div,
  > div > div {
    height: 100%;
  }
`;

const TooltipWrapper = styled.div`
  padding: 20px;

  span {
    margin-top: 8px;
    font-size: 13px;
    display: block;
    color: #515151;
  }

  a {
    display: block;
    font-size: 13px;
    margin-top: 8px;
    color: #44adf8;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const FlexWrapper = styled.div`
  min-width: 250px;
  justify-content: center;
  padding: 0 25px;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  position: relative;

  ${props => props.active && "background-color: rgb(243, 243, 243);"};

  &:hover {
    background-color: #e9f6ff;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5px;
    background-color: #44adf8;
    border-radius: 10px 10px 0 0;
  }

  span {
    margin-right: 10px;
    font-weight: 500;
  }

  p {
    max-width: 245px;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  > div {
    display: flex;
    align-items: center;

    &:after {
      content: "";
      display: block;
      margin-left: 15px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid black;
    }
  }
`;

class PageSelect extends Component {
  state = {
    visible: false,
    modalActive: false
  };

  handleVisibleChange = visible => {
    this.setState({ visible });
  };

  closeDropDown = () => {
    this.setState({ visible: false });
  };

  showModal = () => {
    this.setState({ visible: false, modalActive: true });
  };

  closeModal = () => {
    this.setState({ modalActive: false });
  };

  handlePageCreate = page => {
    const { addPage } = this.props;
    addPage(page);
    window.open(`/content/pages/${page.id}`, "_blank");
  };

  render() {
    const { visible, modalActive } = this.state;
    const { pageName, mode, betas, locale } = this.props;

    const hoverTooltip = (
      <TooltipWrapper>
        {I18n.t("header.pageSelect.tooltip.title")}
        <span>{I18n.t("header.pageSelect.tooltip.details")}</span>
      </TooltipWrapper>
    );

    return (
      <Wrapper>
        <Dropdown
          visible={visible}
          trigger={["click"]}
          onVisibleChange={this.handleVisibleChange}
          overlay={<PageSelectList showModal={this.showModal} />}
        >
          <Dropdown overlay={hoverTooltip}>
            <FlexWrapper active={visible}>
              <div>
                <p>{pageName}</p>
              </div>
            </FlexWrapper>
          </Dropdown>
        </Dropdown>
        <CreatePageModal
          onCreate={this.handlePageCreate}
          onClose={this.closeModal}
          mode={mode}
          language={locale}
          active={modalActive}
          betas={betas}
        />
      </Wrapper>
    );
  }
}

const mapDispatchToProps = {
  addPage
};

const mapStateToProps = state => {
  return {
    betas: state.user ? state.user.beta_testers : null,
    locale: state.i18n.locale,
    mode: state.page && state.page.landing_page ? "landing_page" : "page"
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageSelect);
